import styles from "./SignInWithGoogle.module.scss";
import GoogleIcon from "../../assets/icons/googleLogo";

interface SignInWithGoogleButtonProps {
  onClick: () => void;
  disabled?: boolean;
  text?: string;
}

export default function SignInWithGoogleButton({
  onClick,
  disabled = false,
  text = "Sign in with Google",
}: SignInWithGoogleButtonProps) {
  return (
    <button
      className={styles.signInWithGoogleButton}
      onClick={onClick}
      disabled={disabled}
    >
      <div className={styles.signInWithGoogleButtonState}></div>
      <div className={styles.buttonContentWrapper}>
        <div className={styles.iconWrapper}>
          <GoogleIcon />
        </div>
        <span className={styles.buttonText}>{text}</span>
      </div>
    </button>
  );
}
